// Dark mode is scoped to the study surfaces (the dashboard and the textbook).
// The `.dark` class is toggled on <html> (so portaled dialogs inherit it too),
// but only on those routes; everywhere else is forced light so marketing can
// never inherit dark, and the textbook stays light for signed-out crawlers.

export const THEME_STORAGE_KEY = "dashboard-theme";

// Keep in sync with `isThemedRoute` in DashboardTheme.tsx.
export const THEMED_ROUTE_PREFIXES = ["/dashboard", "/textbook"];

// Runs before first paint in <head> to set the initial class with no flash.
// Mirrors the client provider's logic: dark only on themed routes, default
// light (dark applies only when the user has explicitly chosen it).
export const themeInitScript = `(function(){try{var d=document.documentElement;var p=location.pathname;var themed=p.indexOf('/dashboard')===0||p.indexOf('/textbook')===0;if(!themed){d.classList.remove('dark');return;}var m=localStorage.getItem('${THEME_STORAGE_KEY}');d.classList.toggle('dark',m==='dark');}catch(e){}})();`;
